<template>
  <v-select
    variant="outlined"
    density="compact"
    :items="viewByItems"
    v-model="selectedViewByComputed"
     :label="t('view-by')"
    hide-details
  />
</template>

<script setup>
import { computed, toRefs } from "vue";
import { useRootStore } from "../../../../stores/root";
import { storeToRefs } from "pinia";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const props = defineProps({
  selectedViewBy: {
    type: String,
  },
});
const emit = defineEmits(["update:selectedViewBy"]);

const { selectedViewBy } = toRefs(props);
const store = useRootStore();
const { patches, hierarchyByUser } = storeToRefs(store);

const selectedViewByComputed = computed({
  get() {
    return selectedViewBy.value;
  },
  set(value) {
    if (value === 'patches') store.loadPatches();
    emit("update:selectedViewBy", value);
  },
});

const viewByItems = computed(() => {
  return [
    {
      title: t('location'),
      value: "locations",
    },
    {
      title: t('patch'),
      value: "patches",
    },
    ...(hierarchyByUser.value || []).map((role) => ({
      title: role.text,
      value: role.text,
    })),
  ];
});
</script>
<i18n>
{
  "en": {
    "view-by": "View By",
    "location": "Location",
    "patch": "Patch"
  },
  "es": {
    "view-by": "Filtrar Por",
    "location": "Ubicación",
    "patch": "Grupo"
  }
}
</i18n>
<style scoped>
:deep(.v-select__selection) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}
:deep(.v-input__details) {
  display: none;
}
</style>